import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAPI, getAPI, postAPI, putAPI } from "../../service/http-service";
import { ItemMasterEndpoint } from "../../service/endpointConfig/ItemMasterEndpoint";

let initialState: any = {
  itemMasterResponse: {},
};

export interface ItemMasterCourseProps {
  id: number;
  itemName: string;
  courseId: number;
  quantity: number;
  selected: boolean;
}

export interface ItemPricingProps {
  id?: number;
  centerTypeId: number;
  poRateWithoutTax?: number | string;
  poTaxCgst: number | string;
  poTaxSgst: number | string;
  poTaxTotal: number | string;
  poRateWithTax: number | string;
  studentRateWithoutTax: number | string;
  studentTaxCgst: number | string;
  studentTaxSgst: number | string;
  studentTaxTotal: number | string;
  studentRateWithTax: number | string;
  royaltyRateWithoutTax: number | string;
  royaltyTaxCgst: number | string;
  royaltyTaxSgst: number | string;
  royaltyRateWithTax: number | string;
  fastTrackRoyalty: number | string;
  fastTrackNoOfMonthsFee: number | string;
  royaltyNoOfMonths: number | string;
}
export interface ItemMaserProps {
  id?: number;
  courseId: number | undefined;
  itemCategoryId: number | undefined;
  itemTypeTShirt: boolean | string;
  itemTypeUpfront: boolean | string;
  applicableForInvoice: boolean | string;
  applicableForPo: boolean | string;
  itemName: string | undefined;
  tallyItemCode: string | undefined;
  productId: any;
  itemPricing: ItemPricingProps[];
  itemMasterIds?: any;
  courseLevel: any;
}

export const itemMasterService = createAsyncThunk(
  "master/itemMaster",
  async (item: any) => {
    try {
      let response;
      switch (item.apiAction) {
        case "list":
          response = await getAPI(ItemMasterEndpoint.item);
          break;
        case "LevelDetails":
          response = await getAPI(
            `${ItemMasterEndpoint.levelDetails}/${item.courseLevelId}/course/${item.courseId}?centerTypeId=${item.centerTypeId}`
          );
          break;
        case "MasterCourse":
          response = await getAPI(
            `${ItemMasterEndpoint.masterCourseList}/${item.formValues}`
          );
          break;
        case "listById":
          response = await getAPI(
            `${ItemMasterEndpoint.item}/${item.formValues}`
          );
          break;
        case "create":
          response = await postAPI(ItemMasterEndpoint.item, item.formValues);
          break;
        case "update":
          response = await putAPI(ItemMasterEndpoint.item, item.formValues);
          break;
        case "delete":
          response = await deleteAPI(
            `${ItemMasterEndpoint.item}/${item.formValues}`
          );
          break;
        case "deleteAll":
          response = await deleteAPI(
            `${ItemMasterEndpoint.item}?${item.requestParams}`
          );
          break;
        case "exportExcel":
          response = await postAPI(
            ItemMasterEndpoint.exportExcel,
            item.formValues
          );
          break;
      }

      return response;
    } catch (err) {
      return err;
    }
  }
);

const itemMasterSlice = createSlice({
  name: "itemMaster",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(itemMasterService.fulfilled, (state, action) => {
      state.itemMasterResponse = action.payload;
    });
    builder.addCase(itemMasterService.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const itemMasterReducer = itemMasterSlice.reducer;
export default itemMasterReducer;
